import SparklingDrinkImage1 from '../images/foodImages/sparklingDrinks/SparklingDrink_img1.jpg';

const SparklingDrinks = [
  { id: 1, name: '就愛你', price: 160, description: '', image: SparklingDrinkImage1 },
  { id: 2, name: '浪漫風情', price: 160, description: '', image: SparklingDrinkImage1 },
  { id: 3, name: '夏克絲', price: 160, description: '', image: SparklingDrinkImage1 },
  { id: 4, name: '我愛鑽石', price: 160, description: '', image: SparklingDrinkImage1 },
  {
    id: 5,
    name: '臉紅心跳',
    price: 160,
    description: '',
    image: SparklingDrinkImage1,
  },
  { id: 6, name: '戀愛滋味', price: 160, description: '', image: SparklingDrinkImage1 },
  { id: 7, name: '清涼一下', price: 160, description: '', image: SparklingDrinkImage1 },
  { id: 7, name: '西拉子', price: 160, description: '', image: SparklingDrinkImage1 },
  { id: 7, name: '赤霞珠', price: 160, description: '', image: SparklingDrinkImage1 },
  { id: 7, name: '長相思', price: 160, description: '', image: SparklingDrinkImage1 },
  { id: 7, name: '霞多麗', price: 160, description: '', image: SparklingDrinkImage1 },
];

export default SparklingDrinks;
